import React, { useContext } from 'react';
import Register from 'core/pages/Register';
import { Grid, Button,  Box
} from '@mui/material';
import { AuthContext } from 'core/context';

const UserInfo = ({onBackButtonClick, onSuccess }) => {
  const authContext = useContext(AuthContext);
  const onSignupSuccess = (response) => {
    authContext.updateAuthContext({
      isUserLoggedIn: true,
      authToken: response?.authToken,
      userId: response?.userEntity?.userId,
      data: {
        name: `${response?.userEntity?.firstName} ${response?.userEntity?.lastName}`,
        email: response?.userEntity?.email,
      }
    });
    onSuccess();
  }

  return (
    <Box sx={{ mb: 2, mt:4, px: 4 }} noValidate >
      <Grid container justifyContent="center">
        <Grid container  item xs={12} sm={12} md={6} lg={5}>
          <Register formOnly={true} signupButtonLabel="Next" redirect={false} onSignupSuccess={onSignupSuccess}/>
          <Button sx={{mt: 3}} variant="contained" onClick={onBackButtonClick}> Back </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
 
export default React.memo(UserInfo);
